import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { IconicModule } from '../iconic/iconic.module';
import { OverlayModule } from '../overlay/overlay.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import {
  BottomSheetComponent,
  ContentTemplate,
} from './bottom-sheet.component';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    IconicModule,
    ButtonModule,
    ToolbarModule,
  ],
  declarations: [BottomSheetComponent, ContentTemplate],
  exports: [BottomSheetComponent, ContentTemplate],
})
export class BottomSheetModule {}
